import React from 'react'
import { Card, Button, Box, Paper, Typography } from '@mui/material'
import { ContractDTO } from '../../../../dto/ContractDTO'

type Props = {
  contratosList: ContractDTO[]
  contactoLocal: any
  handleClick: (acciones: any) => void
}

const DisplayContractsDesktop: React.FC<Props> = ({ contratosList, contactoLocal, handleClick }) => {
  return (
    <>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: '10px'
        }}
      >
        {contratosList.map((contrato: ContractDTO) => (
          <Card
            key={contrato.idContrato}
            variant="outlined"
            sx={{
              px: { md: '3em', xs: '0.5em' },
              display: 'flex',
              flexDirection: 'column',
              padding: '10px',
              margin: '20px 22px 22px',
              alignItems: 'flex-start'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                marginBottom: '10px',
                marginTop: '10px'
              }}
            >
              <Box
                sx={{
                  flexDirection: 'column',
                  flexGrow: 1,
                  fontSize: 16,
                  textAlign: 'left',
                  whiteSpace: 'nowrap' // Prevent wrapping
                }}
              >
                <div style={{ fontSize: '20px', fontWeight: 'bold' }}>{contrato.productoNombre}</div>
              </Box>

              <div
                style={{
                  backgroundColor: `#${contrato.color}`,
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  padding: '3px 8px',
                  cursor: 'pointer',
                  fontSize: '18px'
                }}
              >
                {contrato.estadoNombre}
              </div>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                marginBottom: '10px'
              }}
            >
              <Box
                sx={{
                  flexDirection: 'column',
                  flexGrow: 1,
                  fontSize: 16,
                  textAlign: 'left',
                  whiteSpace: 'nowrap'
                }}
              >
                <div style={{ fontSize: '16px' }}>
                  {[
                    contrato.fechaInicioFormateada && `Desde: ${contrato.fechaInicioFormateada}`,
                    contrato.fechaFinFormateada && `Hasta: ${contrato.fechaFinFormateada}`
                  ]
                    .filter(Boolean)
                    .join(', ')}
                </div>
                {contrato.accionesUsuarioList &&
                  contrato.accionesUsuarioList[0].payload?.datosTransferencia?.titular && (
                    <Typography>{`Titular: ${contrato.accionesUsuarioList[0].payload?.datosTransferencia?.titular}`}</Typography>
                  )}
              </Box>
            </Box>
            {contrato.accionesUsuarioList && contactoLocal && (
              <Button
                variant="contained"
                fullWidth
                style={{
                  backgroundColor: contrato.accionesUsuarioList[0].color,
                  border: '1px solid grey',
                  color: 'black',
                  marginTop: '20px'
                }}
                onClick={() => handleClick(contrato.accionesUsuarioList[0])}
              >
                {contrato.accionesUsuarioList[0].boton}
              </Button>
            )}
          </Card>
        ))}
      </div>
    </>
  )
}

export default DisplayContractsDesktop
